import { FC, MouseEvent } from 'react';

import { Button } from 'antd';

import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';

import styles from './EyeButton.module.scss';

interface EyeButtonProps {
  onClick: (e: MouseEvent) => void;
}

const EyeButton: FC<EyeButtonProps> = ({ onClick }) => {
  return (
    <Button
      type="link"
      size="small"
      className={`${styles.eyeButton}`}
      onClick={onClick}
    >
      <EyeIcon />
    </Button>
  );
};

export default EyeButton;
